import { Card } from 'primereact/card';
import { HTMLAttributes, ReactNode } from 'react';
import styles from './ContentCard.module.scss';

interface ContentCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const ContentCard = ({ children }: ContentCardProps) => (
  <div className={`${styles['page-container']}`}>
    <Card className={`${styles['page-card']}`}>{children}</Card>
  </div>
);

export default ContentCard;
